export const LOGIN = "login";
export const LOGOUT = "logout";
export const LOAD_USER = "load_user";
export const REGISTER = "register";
export const REGISTER_FINISH = "register_finish";
export const PWRESET_REQUEST = "pwreset_request";
export const PWRESET = "pwreset";
export const RESET_VALUES_FN = "reset_values_fn";